import { IDTEL_DATA } from "../data/idtelData";

export function idtelTotalItems() {
  return IDTEL_DATA.reduce(
    (sum, micro) =>
      sum + micro.domains.reduce((acc, domain) => acc + domain.count, 0),
    0
  );
}

export function idtelFlatIndex(mIdx, dIdx, row) {
  let idx = 0;
  for (let mi = 0; mi < mIdx; mi += 1) {
    idx += IDTEL_DATA[mi].domains.reduce(
      (acc, domain) => acc + domain.count,
      0
    );
  }
  for (let di = 0; di < dIdx; di += 1) {
    idx += IDTEL_DATA[mIdx].domains[di].count;
  }
  return idx + row;
}

/** Índice del primer campo interactivo del protocolo (todos usan 1). */
export function getFirstFieldIndex() {
  return 1;
}

/**
 * Fase inicial de la guía UX:
 * - age: titilar edad en la barra de herramientas
 * - field: titilar solo el primer campo
 * - done: sin titileo
 */
export function initialGuidePhase(test) {
  if (!test) return "done";
  if (test.requiresAge) return "age";
  return "field";
}
